var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tab === 0)?_c('log-table'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }